import { memo } from 'react'
import { showNotification } from '@mantine/notifications'
import { Button, Modal } from '@ow/comps'
import { downloaderUrl } from '@ow/utils'
import {
  getTaskResult,
  editDownloadTask,
  destoryDownloadTask,
} from '@vt/apis/lib-ex/v2/downloadCenter'

// 弹框底部按钮组件
const FooterButton = ({ close, otherFooterData }) => {
  return (
    <div className="flex justify-center items-center">
      <Button stroke style={{ marginRight: '10px' }} onClick={close}>
        取消
      </Button>
      <Button
        type="primary"
        onClick={() => {
          otherFooterData()
          close()
        }}
      >
        确认
      </Button>
    </div>
  )
}

const DownLoadFooterButton = ({ close }) => {
  return (
    <div className="flex justify-center items-center">
      <Button type="primary" onClick={close}>
        关闭
      </Button>
    </div>
  )
}
// 弹框
const Content = ({ cancel }) => {
  return (
    <Modal
      trigger={
        <Button type="primary" opacityType="transparent">
          取消
        </Button>
      }
      otherFooterData={cancel}
      showCloseButton
      size="sm"
      title="确认取消"
      footer={FooterButton}
    >
      <div>是否确认取消当前下载任务？</div>
    </Modal>
  )
}
const DownLoad = () => {
  return (
    <Modal
      trigger={
        <Button type="primary" opacityType="transparent">
          下载
        </Button>
      }
      showCloseButton
      size="sm"
      title="下载"
      footer={DownLoadFooterButton}
    >
      <div>
        <h4>操作步骤如下：</h4>
        1、点击下载
        <a className="text-primary-700" href={downloaderUrl}>
          明察暗访下载器
        </a>
        （仅支持windows系统）
        <br />
        2、安装后使用当前账号登录进行下载
      </div>
    </Modal>
  )
}

// 组件
const Operator = ({ task, refresh }) => {
  const { state, id, toDownloader } = task

  const download = async () => {
    const res = await getTaskResult(id)

    if (!res.data?.length) {
      showNotification({
        title: '未找到任务结果',
      })
      return
    }
    const record = res.data.find((r) => r.state === 'SUCCESS')

    if (!record || !record.reportOss) {
      showNotification({
        title: '未找到文件地址',
      })
      return
    }

    window.open('', '_self').location.href = record.reportOss
  }

  const editTaskState = async (newState) => {
    const res = await editDownloadTask({ id, state: newState })
    showNotification({
      title: res.message,
    })
    refresh()
  }

  const deleteTask = async () => {
    const res = await destoryDownloadTask([id])
    showNotification({
      title: res.message,
    })
    refresh()
  }

  if (state === 'CANCEL') {
    return (
      <div className="flex">
        <Button type="primary" opacityType="transparent" onClick={deleteTask}>
          删除
        </Button>
      </div>
    )
  }

  if (state === 'READY' || !state) {
    return (
      <div className="flex">
        {toDownloader ? (
          <DownLoad />
        ) : (
          <Button type="primary" opacityType="transparent" onClick={download}>
            下载
          </Button>
        )}
        <Button type="primary" opacityType="transparent" onClick={deleteTask}>
          删除
        </Button>
      </div>
    )
  }
  if (state === 'TIMEOUT') {
    return (
      <div className="flex">
        <Button
          type="primary"
          opacityType="transparent"
          onClick={() => editTaskState('WAITING')}
        >
          重新生成
        </Button>
        <Button type="primary" opacityType="transparent" onClick={deleteTask}>
          删除
        </Button>
      </div>
    )
  }
  if (['WAITING', 'RUNNING'].includes(state)) {
    return (
      <div className="flex">
        <Button type="primary" opacityType="transparent" onClick={refresh}>
          刷新
        </Button>
        <Content cancel={() => editTaskState('CANCEL')} />
      </div>
    )
  }

  return null
}
export default memo(Operator)
